import { AxiosInstance } from 'axios'

export default (instance: AxiosInstance): void => {
	// @ts-ignore
	instance.interceptors.response.use(null, err => {
		let message

		if (err.config && err.response) {
			// eslint-disable-next-line max-len
			message = `${err.config.method.toUpperCase()} ${err.config.url} responded with status ${err.response.status
				}`
		} else {
			message = err.message
		}

		// eslint-disable-next-line no-console
		console.error(`ERROR: ${message}`)

		return Promise.reject(err)
	})
}
